import { IEspAdditionalInfo, IEspRequest } from '../../model/types'

export interface IEspRequestFormData extends IEspAdditionalInfo {
  /** Free text: there is no sponsor directory. */
  sponsorName: string
  sponsorEmail: string
  justification: string
}

const EMPTY_ADDITIONAL_INFO: IEspAdditionalInfo = {
  employeesCount: null,
  annualRevenueM: null,
  accountValue: '',
  isBusinessGrowing: false,
  accountContact: '',
  missionAndVision: '',
  keyChallenges: '',
  productsAndSolutions: '',
}

/**
 * Shared by the modal content and footer (they register the same form key, mdf pattern):
 * Section 2 is pre-filled from the partner's most recent request when there is one.
 */
export const getInitialEspRequestForm = (lastRequest: IEspRequest | null): IEspRequestFormData => ({
  sponsorName: '',
  sponsorEmail: '',
  justification: '',
  ...(lastRequest ? lastRequest.additionalInfo : EMPTY_ADDITIONAL_INFO),
})
